import '@/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import { TooltipProvider } from '@/components/ui/tooltip';
import { ConfigProvider } from '@/lib/ConfigContext';
import { AuthProvider, useAuth } from '@/lib/AuthContext';
import AppLayout from '@/components/layout/AppLayout';
import Login from '@/pages/Login';
import Dashboard from '@/pages/Dashboard';
import Viviendas from '@/pages/Viviendas';
import Egresos from '@/pages/Egresos';
import Credito from '@/pages/Credito';
import Prestamos from '@/pages/Prestamos';
import FlujoCaja from '@/pages/FlujoCaja';
import Configuracion from '@/pages/Configuracion';
import Usuarios from '@/pages/Usuarios';
import AvanceObra from '@/pages/AvanceObra';
import Estimaciones from '@/pages/Estimaciones';
import Facturacion from '@/pages/Facturacion';
import TimelineViviendas from '@/pages/TimelineViviendas';
import AvanceSemanal from '@/pages/AvanceSemanal';
import CatalogoObra from '@/pages/CatalogoObra';
import Pagos from '@/pages/Pagos';
import Validacion from '@/pages/Validacion';
import NotificacionesConfig from '@/pages/NotificacionesConfig';

function AppRoutes() {
  const { user, loading, isAdmin, canWrite } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#FAFBFD] flex items-center justify-center">
        <div className="h-10 w-10 rounded-xl bg-gradient-to-br from-[#F05A28] to-[#FF6A3D] animate-pulse" />
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <ConfigProvider>
      <TooltipProvider>
        <AppLayout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/viviendas" element={<Viviendas />} />
            <Route path="/egresos" element={<Egresos />} />
            <Route path="/credito" element={<Credito />} />
            <Route path="/prestamos" element={<Prestamos />} />
            <Route path="/flujo-caja" element={<FlujoCaja />} />
            <Route path="/avance-obra" element={<AvanceObra />} />
            <Route path="/estimaciones" element={<Estimaciones />} />
            <Route path="/facturacion" element={<Facturacion />} />
            <Route path="/timeline" element={<TimelineViviendas />} />
            <Route path="/avance-semanal" element={<AvanceSemanal />} />
            <Route path="/catalogo-obra" element={<CatalogoObra />} />
            <Route path="/pagos" element={<Pagos />} />
            <Route path="/validacion" element={<Validacion />} />
            <Route path="/notificaciones-config" element={<NotificacionesConfig />} />
            {canWrite && <Route path="/configuracion" element={<Configuracion />} />}
            {isAdmin && <Route path="/usuarios" element={<Usuarios />} />}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AppLayout>
        <Toaster position="bottom-right" />
      </TooltipProvider>
    </ConfigProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
